<div class="td-wb-loading-indicator-panel">
  @if (customLoadingIndicator()) {
    <ng-content/>
  } @else {
    <td-wb-detailed-loading-indicator position="top" />
  }
</div>
